var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-container"},[_c('div',{staticClass:"image-container"},[_c('div',{staticClass:"row"},[_c('img',{attrs:{"src":_vm.imgList}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }